import { InfoCircleOutlined } from "@ant-design/icons";
import React from "react";

const InfoWarning: React.FC = () => (
	<InfoCircleOutlined
		style={{
			backgroundColor: "#FCFCD7",
			color: "#FFBC00",
			fontSize: "25px",
			padding: "10px",
			borderRadius: "10px",
			border: "0.5px solid #FFBC00",
		}}
	/>
);
export default InfoWarning;
